import * as React from 'react'
import { memo } from 'react'
const SvgSize = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
  >
    <path d="m10 20-3.626-3.626.44-.44 2.885 2.885v-5.8h.6v5.8l2.885-2.885.44.44Zm-6.429-6.429L0 10l3.6-3.6.44.44-2.857 2.857h5.8v.6h-5.8l2.83 2.857Zm12.857 0-.44-.44 2.83-2.83h-5.8v-.6h5.8l-2.83-2.857.44-.412L20 10ZM9.697 6.978v-5.8l-2.83 2.83-.44-.44L10 0l3.571 3.571-.44.44-2.83-2.83v5.8Z" />
  </svg>
)
const Memo = memo(SvgSize)
export default Memo
